// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"8e824663","268":"644810a0","281":"9909a584","446":"ef9fcd28","478":"140bce9e"}[chunkId] + ".css";
};